// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ITotalClaimSpendResponseDto
 */
export interface ITotalClaimSpendResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ITotalClaimSpendResponseDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ITotalClaimSpendResponseDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof ITotalClaimSpendResponseDto
     */
    total_claim_spend?: number;
    /**
     * 
     * @type {string}
     * @memberof ITotalClaimSpendResponseDto
     */
    account_type?: ITotalClaimSpendResponseDtoAccountTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum ITotalClaimSpendResponseDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the ITotalClaimSpendResponseDto interface.
 */
export function instanceOfITotalClaimSpendResponseDto(value: object): value is ITotalClaimSpendResponseDto {
    return true;
}

export function ITotalClaimSpendResponseDtoFromJSON(json: any): ITotalClaimSpendResponseDto {
    return ITotalClaimSpendResponseDtoFromJSONTyped(json, false);
}

export function ITotalClaimSpendResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ITotalClaimSpendResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'total_claim_spend': json['total_claim_spend'] == null ? undefined : json['total_claim_spend'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
    };
}

export function ITotalClaimSpendResponseDtoToJSON(json: any): ITotalClaimSpendResponseDto {
    return ITotalClaimSpendResponseDtoToJSONTyped(json, false);
}

export function ITotalClaimSpendResponseDtoToJSONTyped(value?: ITotalClaimSpendResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'plan_name': value['plan_name'],
        'total_claim_spend': value['total_claim_spend'],
        'account_type': value['account_type'],
    };
}

